import React from "react";
import { FaUniversity, FaHourglassHalf } from "react-icons/fa";

const PRIMARY = "#007BFF";

const CARD_CONFIG = {
  active: {
    icon: FaUniversity,
    accentBg: "bg-emerald-50",
    accentText: "text-emerald-600",
    label: "Partnered Providers",
    hint: "COE or fee paid (incl. discontinued)",
  },
  inactive: {
    icon: FaHourglassHalf,
    accentBg: "bg-amber-50",
    accentText: "text-amber-600",
    label: "Potential Partners",
    hint: "No enrollments yet",
  },
};

export const PROVIDER_INSIGHTS_LIST_TABS = [
  { id: "active", ...CARD_CONFIG.active },
  { id: "inactive", ...CARD_CONFIG.inactive },
];

function ProviderInsightsListTabs({ value, onChange, tabCounts = {} }) {
  return (
    <div className="provider-insights-list-tabs flex flex-wrap justify-center gap-3">
      {PROVIDER_INSIGHTS_LIST_TABS.map((tab) => {
        const cfg = CARD_CONFIG[tab.id];
        const Icon = cfg.icon;
        const selected = value === tab.id;
        const count = tabCounts[tab.id] ?? 0;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange?.(tab.id)}
            className={`cms-commissions-report-tab group relative flex w-full min-w-0 max-w-[300px] flex-1 items-center gap-3 overflow-hidden rounded-xl border px-4 py-2.5 text-left transition-all duration-200 ${
              selected
                ? "shadow-sm"
                : "border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm"
            }`}
            style={{
              outline: "none",
              ...(selected
                ? {
                    backgroundColor: "rgba(0, 123, 255, 0.14)",
                    borderColor: PRIMARY,
                    boxShadow: "inset 0 0 0 1px rgba(0, 123, 255, 0.18)",
                  }
                : null),
            }}
          >
            {selected && (
              <span
                className="absolute inset-x-0 top-0 h-[3px] rounded-t-xl"
                style={{ backgroundColor: PRIMARY }}
                aria-hidden
              />
            )}

            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                selected ? "" : cfg.accentBg
              } ${selected ? "" : cfg.accentText}`}
              style={
                selected
                  ? { backgroundColor: "rgba(0, 123, 255, 0.16)", color: PRIMARY }
                  : undefined
              }
            >
              <Icon size={16} />
            </span>

            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-2">
                <p
                  className="truncate text-[14px] font-semibold leading-tight"
                  style={{ color: selected ? PRIMARY : "#374151" }}
                >
                  {cfg.label}
                </p>
                <p
                  className="shrink-0 text-[14px] font-bold tabular-nums leading-tight"
                  style={{ color: selected ? PRIMARY : "#35314d" }}
                >
                  {count.toLocaleString()}
                </p>
              </div>
              <p className="mt-0.5 truncate text-[12px] leading-tight text-gray-500">
                {cfg.hint}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default ProviderInsightsListTabs;
